<!-- box grid -->
<div class="fuse-card auto-width mat-card mb-12 p-0">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
        class="dis-block">

        <div *ngIf="isLoading" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
        <div class="p-10" *ngIf="!isLoading">
            <div class="dis-flex">

                <div class="fuse-card auto-width mat-card mb-12  m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader m-b-10">Abs. Mensual</div>

                            <button mat-icon-button class="fuse-widget-flip-button" aria-label="more"
                                (click)="openChartPopup(chartTypes.Absentismo)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                        <div class="m-t-5 text-center">
                            <span> {{(kpiData.kpiAbsenteeism.absentismo) ?
                                (kpiData.kpiAbsenteeism.absentismo | number : '1.1-1') + "%" : "N/A"}}</span>
                            <span *ngIf="kpiData.kpiAbsenteeism.absentismo && kpiData.kpiAbsenteeism.absAnterior">
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absentismo > kpiData.kpiAbsenteeism.absAnterior"
                                    class="mat-icon notranslate green-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_received
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absentismo < kpiData.kpiAbsenteeism.absAnterior"
                                    class="mat-icon notranslate red-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_made
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absentismo === kpiData.kpiAbsenteeism.absAnterior"
                                    class="mat-icon notranslate blue-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">drag_handle
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="fuse-card auto-width mat-card mb-12 m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader m-b-10">Abs. Acumulado</div>

                            <button mat-icon-button class="fuse-widget-flip-button" aria-label="more"
                                (click)="openChartPopup(chartTypes.Acumulado)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                        <div class="m-t-5 text-center">
                            <span> {{(kpiData.kpiAbsenteeism.absAcumulado) ?
                                (kpiData.kpiAbsenteeism.absAcumulado | number : '1.1-1') + "%" : "N/A"}}</span>
                            <span *ngIf="kpiData.kpiAbsenteeism.absAcumulado && kpiData.kpiAbsenteeism.absAcumAnterior">
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absAcumulado > kpiData.kpiAbsenteeism.absAcumAnterior"
                                    class="mat-icon notranslate green-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_received
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absAcumulado < kpiData.kpiAbsenteeism.absAcumAnterior"
                                    class="mat-icon notranslate red-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_made
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absAcumulado === kpiData.kpiAbsenteeism.absAcumAnterior"
                                    class="mat-icon notranslate blue-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">drag_handle
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="fuse-card auto-width mat-card mb-12 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader m-b-10">Abs. Interanual</div>

                            <button mat-icon-button class="fuse-widget-flip-button" aria-label="more"
                                (click)="openChartPopup(chartTypes.Interanual)">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                        <div class="m-t-5 text-center">
                            <span> {{(kpiData.kpiAbsenteeism.absInteranual) ?
                                (kpiData.kpiAbsenteeism.absInteranual | number : '1.1-1') + "%" : "N/A"}}</span>
                            <span
                                *ngIf="kpiData.kpiAbsenteeism.absInteranual && kpiData.kpiAbsenteeism.absInterAnterior">
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absInteranual > kpiData.kpiAbsenteeism.absInterAnterior"
                                    class="mat-icon notranslate green-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_received
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absInteranual < kpiData.kpiAbsenteeism.absInterAnterior"
                                    class="mat-icon notranslate red-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">call_made
                                </mat-icon>
                                <mat-icon role="img"
                                    *ngIf="kpiData.kpiAbsenteeism.absInteranual === kpiData.kpiAbsenteeism.absInterAnterior"
                                    class="mat-icon notranslate blue-fg mr-4 material-icons mat-icon-no-color arrow-grow"
                                    aria-hidden="true" data-mat-icon-type="font">drag_handle
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dis-flex">
                <div class="fuse-card auto-width mat-card mb-12 m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader">Bajas Activas</div>
                        </div>
                        <div class="m-t-17 text-center">
                            <span> {{kpiData.kpiLeave.bajasActivas | number : '2.0-0'}}</span>
                        </div>

                    </div>
                </div>
                <div class="fuse-card auto-width mat-card mb-12 m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h3 cardHeader">No Gestionadas</div>
                        </div>
                        <div class="m-t-17 text-center">
                            <span> {{kpiData.kpiLeave.noGestionadas | number : '2.0-0'}}</span>
                        </div>
                    </div>
                </div>
                <div class="fuse-card auto-width mat-card mb-12 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h3 cardHeader">NJ</div>
                        </div>
                        <div class="m-t-17 text-center">
                            <span> {{kpiData.kpiLeave.noJustificadas | number : '2.0-0'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dis-flex">
                <div class="fuse-card auto-width mat-card m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader">JA</div>
                        </div>
                        <div class="m-t-17 text-center">
                            <span> {{kpiData.kpiLeave.justificadasConAlerta | number : '2.0-0'}}</span>
                        </div>
                    </div>
                </div>
                <div class="fuse-card auto-width mat-card m-r-10 p-0 comp-stat-box ">
                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                        class="dis-block p-10">
                        <div class="pl-8 pr-8 m-5px float-left" fxLayout="row" fxLayoutAlign="center center">
                            <div class="h4 cardHeader">Rechazadas</div>
                        </div>
                        <div class="m-t-17 text-center">
                            <span> 06</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!--/ box grid -->